export default "__VITE_PUBLIC_ASSET__ba50ce19__"